import { useTranslation } from "react-i18next";
import requets from "../../../api";
import { useSelector } from "react-redux";

import { useEffect, useState } from "react";
import { useAppAuth } from "../../../context/use-app-auth";
export default function useLamp() {
  const auth = useAppAuth();
  const req = requets(auth.user?.access_token);
  const { t } = useTranslation("global");
  const controlPanel = useSelector((state) => state.controlPanel);
  const [data, setData] = useState([]);
  const [device, setDevice] = useState({});

  useEffect(() => {
    const { date, department, county, location, devEui } = controlPanel;
    req
      .get("/device", {
        ...date,
        department,
        county,
        location,
        devEui,
      })
      .then((response) => {
        const devicesActive = Array.isArray(response.data?.data)
          ? response.data.data.filter((d) => d.isActive === true)
          : [];
        setData(devicesActive);
      })
      .catch(() => setData([]));
  }, [controlPanel]);

  return {
    t,
    data,
    device,
    setDevice,
  };
}
